import React, { useEffect, useState } from "react";
import "../Custom.css";

import { useSelector } from 'react-redux';

const PushDrawer = ({ isOpen, onClose, onSave, initialData, authToken, nodeId }) => {

  const [title, setTitle] = useState(
    initialData?.pushConfig?.title || ""
  );
  const [message, setMessage] = useState(
    initialData?.pushConfig?.message || ""
  );
  const [link, setLink] = useState(
    initialData?.pushConfig?.link || ""
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageBase64, setImageBase64] = useState("");
  const [imageRemoved, setImageRemoved] = useState(false);

  const notificationDetails = useSelector(
    (state) => state.journey.notification_details || []
  );

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('Please select a valid image file');
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size should be less than 5MB');
        return;
      }
      
      setSelectedImage(file);
      setImageRemoved(false);
      
      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result || "";
        setImagePreview(dataUrl);
        const commaIdx = String(dataUrl).indexOf(",");
        const base64 = commaIdx !== -1 ? String(dataUrl).slice(commaIdx + 1) : String(dataUrl);
        setImageBase64(base64);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
    setImageBase64("");
    setImageRemoved(true);
  };

  useEffect(() => {
    if (initialData?.pushConfig) {
      setTitle(initialData.pushConfig.title || "");
      setMessage(initialData.pushConfig.message || "");
      setLink(initialData.pushConfig.link || "");
      setSelectedImage(initialData.pushConfig.selectedImage || null);
      const preview = initialData.pushConfig.imagePreview || null;
      setImagePreview(preview);
      if (preview) {
        const commaIdx = String(preview).indexOf(",");
        const base64 = commaIdx !== -1 ? String(preview).slice(commaIdx + 1) : String(preview);
        setImageBase64(base64);
      } else {
        setImageBase64("");
      }
    }
  }, [initialData]);

  useEffect(() => {
    try {
      const map = notificationDetails?.data || {};
      const key = String(nodeId || initialData?.id || "");
      const detail = map[key];
      const url = detail?.image;
      if (url && !selectedImage) {
        const withCacheBuster = (u) => (u ? `${u}${u.includes('?') ? '&' : '?'}t=${Date.now()}` : '');
        setImagePreview(withCacheBuster(url));
        setImageBase64("");
      }
    } catch (_) {}
  }, [notificationDetails, nodeId, initialData, selectedImage]);


  const handleSave = () => {
    if (!title.trim()) {
      alert('Notification Title is required');
      const titleInput = document.querySelector('input[placeholder="Enter notification title"]');
      if (titleInput) titleInput.focus();
      return;
    }
    if (!message.trim()) {
      alert('Notification Message is required');
      const messageInput = document.querySelector('textarea[placeholder="Enter notification message"]');
      if (messageInput) messageInput.focus();
      return;
    }

    onSave({
      wp_id: "",
      title: title,
      message: message,
      link: link,
      image: imageBase64
        ? {
            base64: imagePreview,
            file: selectedImage
              ? { name: selectedImage.name, size: selectedImage.size, type: selectedImage.type }
              : null,
          }
        : null,
      description: message,
      image_removed: imageRemoved ? 1 : 0,
      is_image: imagePreview ? 1 : 0,
    });
  };

  const handleClose = () => {
    setTitle("");
    setMessage("");
    setSelectedImage(null);
    setImagePreview(null);
    setImageBase64("");
    onClose();
  };


  return (
    <>
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}

      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
          <div className="nav nav-pills">
            Push Notification Template
          </div>
          <button className="btn-close" onClick={handleClose}></button>
        </div>

        <div className="drawer-body p-4">
             
              {/* Push Notification Title */}
              <div className="mb-3">
                <label className="form-label">Notification Title <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter notification title"
                  required
                />
              </div>

              
              {/* Push Notification Message */}
              <div className="mb-3">
                <label className="form-label">Notification Message <span className="text-danger">*</span></label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter notification message"
                  required
                />
              </div>
             
              <div className="mb-3">
                <label className="form-label">Deep Link</label>
                <input
                  type="text"
                  className="form-control"
                  value={link}
                onChange={(e) => setLink(e.target.value)}
                  placeholder="Enter link"
                />
              </div>

              {/* Image Upload Section - Always Visible */}
              <div className="mb-3">
                <label className="form-label small">Select Image</label>
                <input 
                  type="file" 
                  className="form-control" 
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <div className="form-text small">
                  Upload an image to include in your push notification. Supported formats: JPG, PNG, GIF. Max size: 5MB.
                </div>
              </div>
                                            {/* Show template preview if available */}
             
                  {imagePreview && (
                    <div className="template-preview">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <p className="text-muted mb-0">Image Preview:</p>
                        <button 
                          type="button" 
                          className="btn btn-sm btn-outline-danger"
                          onClick={removeImage}
                        >
                          Remove
                        </button>
                      </div>
                      <div className="border rounded p-3">
                        <img 
                          src={imagePreview} 
                          alt="Preview" 
                          style={{ 
                            maxWidth: '100%', 
                            maxHeight: '300px', 
                            objectFit: 'contain' 
                          }} 
                        />
                      </div>
                    </div>
                  )}
              
                {/* Description field removed as requested; still sent in payload */}

            </div>
        
        {/* Footer */}
        <div className="bg-light p-3 d-flex justify-content-end gap-2">
          <button
            onClick={handleSave}
            className="btn btn-info text-white"
          >
            SAVE
          </button>
        </div>
      </div>
    </>
  );
};

export default PushDrawer;
